import { render, staticRenderFns } from "./AutoApprovedApplications.vue?vue&type=template&id=6f62457b"
import script from "./AutoApprovedApplications.vue?vue&type=script&lang=js"
export * from "./AutoApprovedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports